import React, { useState, useEffect } from "react";
import * as R from "ramda";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as moment from "moment";
import { Row, Col, Container } from "react-bootstrap";
import styled, { css } from "styled-components";
import Spinner from "../ui/Spinner";
import Loader from "../ui/Loader";

const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: #d4d4d5;
  margin: 4em 0;
`;

const Title = styled.div`
  text-align: left;
  font: 14px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #000000;
  margin-top: 1em;
  margin-bottom: 1em;
`;

const TitleRow = styled(Row)`
  background-color: #00147b;
  color: #ffffff;
  min-height: 50px;

  & [class*="col"] {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const DetailRow = styled(Row)`
  background-color: ${(props) =>
    props.status.toLowerCase() === "late" ? "#DC3545" : "#ffffff"};
  color: ${(props) =>
    props.status.toLowerCase() === "late"
      ? "#ffffff"
      : props.status.toLowerCase() === "pending"
      ? "#28A745"
      : "#000000"};
  min-height: 50px;

  & [class*="col"] {
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(props) =>
      props.status.toLowerCase() === "late"
        ? "#ffffff"
        : props.status.toLowerCase() === "pending"
        ? "#28A745"
        : "#000000"};
  }
`;

const PortraitContainerCol = styled(Col)`
  border: 1px solid #888888;
`;

const PortraitTitleRow = styled(Row)`
  background-color: ${(props) =>
    props.status.toLowerCase() === "late"
      ? "#DC3545"
      : props.status.toLowerCase() === "pending"
      ? "#B2B2B2"
      : "#0A944A"};
  min-height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
`;

const PortraitDetailRow = styled(Row)`
  background-color: #ffffff;
  min-height: 84px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #888888;
  padding: 0.5em;
`;

export const JobBoardBallList = (props) => {
  const {
    jobs,
    loadingCustomer,
    bowlerID,
    ballID,
    plugin_settings,
    jobServices,
    deviceInfo,
  } = props;

  const { t } = useTranslation();
  const navigate = useNavigate();
  const isPortrait = deviceInfo.isPortrait;

  return loadingCustomer && jobs.length === 0 ? (
    <Spinner />
  ) : (
    <Container>
      <Line />
      <Title>{t("jobBoard.history")}</Title>
      {!isPortrait && (
        <TitleRow>
          <Col xs={1}>{t("jobBoard.date")}</Col>
          <Col xs={6}>{t("jobBoard.title")}</Col>
          {plugin_settings.job_board_include_price && (
            <Col xs={1}>{t("jobBoard.total")}</Col>
          )}
          <Col xs={1}>{t("jobBoard.due")}</Col>
          <Col xs={1}>{t("jobBoard.completed")}</Col>
          <Col xs={2}>{t("jobBoard.status")}</Col>
        </TitleRow>
      )}
      {jobs.map((job) => {
        const selectedJobServices = R.map(
          R.path(["job_service", "id"]),
          job.job_details || []
        );

        const selectedServices = R.join(
          ", ",
          R.map(
            R.prop("name"),
            R.filter(
              (jobService) => R.contains(jobService.id, selectedJobServices),
              jobServices || []
            )
          )
        );
        return (
          <Link
            to={`/arsenal/${bowlerID}/ball/${ballID}/job/${job.id.toString()}`}
          >
            {!isPortrait && (
              <DetailRow
                status={
                  job.status !== "complete"
                    ? moment(job.date_due).isSameOrBefore(moment(), "day")
                      ? "late"
                      : job.status
                    : job.status
                }
              >
                <Col xs={1}>
                  {moment(job.date_created).format("MM/DD/YYYY")}
                </Col>
                <Col xs={6}>{selectedServices}</Col>
                {plugin_settings.job_board_include_price && (
                  <Col xs={1}>
                    {job.discount ||
                      R.sum(
                        R.map(R.path(["price"]), job.job_details || [])
                      )}{" "}
                    {plugin_settings.job_board_currency}
                  </Col>
                )}
                <Col xs={1}>{moment(job.date_due).format("MM/DD/YYYY")}</Col>
                <Col xs={1}>
                  {job.date_completed
                    ? moment(job.date_completed).format("MM/DD/YYYY")
                    : ""}
                </Col>
                <Col xs={2}>
                  {t(
                    `jobBoard.${
                      job.status !== "complete"
                        ? moment(job.date_due).isSameOrBefore(moment(), "day")
                          ? moment(job.date_due).isSame(moment(), "day")
                            ? "late_today"
                            : "late"
                          : job.status
                        : job.status
                    }`
                  ).toUpperCase()}
                </Col>
              </DetailRow>
            )}
            {isPortrait && (
              <Row>
                <PortraitContainerCol xs={12}>
                  <PortraitTitleRow
                    status={
                      job.status !== "complete"
                        ? moment(job.date_due).isSameOrBefore(moment(), "day")
                          ? "late"
                          : job.status
                        : job.status
                    }
                  >{`${
                    job.date_completed
                      ? moment(job.date_completed).format("MM/DD/YYYY")
                      : moment(job.date_due).format("MM/DD/YYYY")
                  } - ${t(
                    `jobBoard.${
                      job.status !== "complete"
                        ? moment(job.date_due).isSameOrBefore(moment(), "day")
                          ? moment(job.date_due).isSame(moment(), "day")
                            ? "late_today"
                            : "late"
                          : job.status
                        : job.status
                    }`
                  ).toUpperCase()}`}</PortraitTitleRow>
                  <PortraitDetailRow>
                    <Row>
                      <Col xs={12}>{selectedServices}</Col>
                    </Row>
                    {plugin_settings.job_board_include_price && (
                      <Row>
                        <Col xs={12} style={{ fontSize: "1.5em" }}>
                          {job.discount ||
                            R.sum(
                              R.map(R.path(["price"]), job.job_details || [])
                            )}{" "}
                          {plugin_settings.job_board_currency}
                        </Col>
                      </Row>
                    )}
                  </PortraitDetailRow>
                </PortraitContainerCol>
              </Row>
            )}
          </Link>
        );
      })}
    </Container>
  );
};
